import React from 'react';
import {
    MenuItemLink,
    WithPermission
} from 'admin-on-rest';
import {resolveAccess} from '../shared/authFunctions';
import LogoutButton from '../buttons/LogoutButton';

import HomeIcon from 'material-ui/svg-icons/action/home';
import KitIcon from 'material-ui/svg-icons/hardware/tablet-android';
import LocationIcon from 'material-ui/svg-icons/action/store';
import ProductIcon from 'material-ui/svg-icons/action/view-list';
import InventoryIcon from 'material-ui/svg-icons/maps/local-shipping';
import LoyaltyIcon from 'material-ui/svg-icons/action/card-giftcard';
import UserIcon from 'material-ui/svg-icons/social/person';
import SettingsIcon from 'material-ui/svg-icons/action/settings';

/**
 * The Sidebar Menu. Displays links based on User permission.
 *
 * @param onMenuTap
 * @return {*}
 * @constructor
 */
export const MainMenu = ({onMenuTap}) => {
    return (
        <div>
            <MenuItemLink to="/" primaryText="Dashboard"
                          leftIcon={<HomeIcon/>} onClick={onMenuTap} className="menu-link"/>

            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['locations', 'locations_vo'])}>
                <MenuItemLink to="/Location" primaryText="Locations"
                              leftIcon={<LocationIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission
                resolve={(props) => resolveAccess(props.permissions, ['products_all', 'products_np', 'products_vo'], [])}>
                <MenuItemLink to="/Product" primaryText="Products"
                              leftIcon={<ProductIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory', 'inventory_vo'])}>
                <MenuItemLink to="/Inventory" primaryText="Inventory"
                              leftIcon={<InventoryIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission
                resolve={(props) => resolveAccess(props.permissions, ['loyalty_all', 'loyalty_csr', 'loyalty_vo'])}>
                <MenuItemLink to="/Loyalty" primaryText="Loyalty Program"
                              leftIcon={<LoyaltyIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit', 'pos_kit_vo'])}>
                <MenuItemLink to="/POSKit" primaryText="POS Kits"
                              leftIcon={<KitIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_users', 'pos_users_vo'])}>
                <MenuItemLink to="/POSUser" primaryText="POS Users"
                              leftIcon={<UserIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <WithPermission
                resolve={(props) => resolveAccess(props.permissions, ['configuration', 'configuration_vo'])}>
                <MenuItemLink to="/Configuration" primaryText="Configuration"
                              leftIcon={<SettingsIcon/>} onClick={onMenuTap} className="menu-link"/>
            </WithPermission>

            <LogoutButton/>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/Fuse/global/menu.js